import React from 'react';

interface ProgressHeaderProps {
  progressPercentage: number;
  completedLessons: number;
  totalLessons: number;
}

const ProgressHeader: React.FC<ProgressHeaderProps> = ({ 
  progressPercentage, 
  completedLessons, 
  totalLessons 
}) => {
  return (
    <div className="bg-gradient-to-br from-indigo-600 via-indigo-500 to-purple-600 rounded-3xl p-6 shadow-xl relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mr-8 -mt-8 w-32 h-32 bg-white/10 rounded-full blur-2xl"></div>
      <div className="absolute bottom-0 left-0 -ml-8 -mb-8 w-24 h-24 bg-indigo-400/20 rounded-full blur-xl"></div>
      
      <div className="relative z-10">
        <div className="flex items-center justify-between mb-4">
          <div>
            <span className="text-indigo-100 text-xs font-bold uppercase tracking-widest">Seu progresso</span>
            <h2 className="text-white text-2xl font-black">Continue sua jornada</h2>
          </div>
          <div className="bg-white/20 backdrop-blur-md px-3 py-1 rounded-2xl border border-white/20">
            <span className="text-white font-black text-sm">{progressPercentage}%</span>
          </div>
        </div>
        
        <div className="w-full bg-white/20 backdrop-blur-sm rounded-full h-3 mb-5 overflow-hidden">
          <div 
            className="bg-white h-full rounded-full transition-all duration-1000 ease-out shadow-[0_0_10px_rgba(255,255,255,0.5)]" 
            style={{ width: `${progressPercentage}%` }} 
          />
        </div>
        
        <div className="flex items-center justify-between text-indigo-50 text-[11px] font-bold uppercase tracking-wider">
          <div className="flex items-center gap-1.5">
            <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
            <span>{completedLessons} completas</span>
          </div>
          <div>{totalLessons - completedLessons} para finalizar</div>
        </div>
      </div>
    </div>
  );
};

export default ProgressHeader;
